import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FilterFooter from './V2FilterFooter';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import V2FormCascader from '../../../Form/V2FormCascader/V2FormCascader';
import { Cascader } from 'antd';

const V2FilterCascader: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  multiple,
  options = [],
  comType,
  extra,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name]);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      if (isNotEmptyAny(targetValue?.value)) {
        methods.confirm(undefined, true);
      } else {
        methods.confirm(undefined);
      }
      setTargetValue(undefined);
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon, styles.V2FilterRangePicker])}>
      <div>
        <V2FormCascader
          placeholder='请选择'
          noStyle
          config={{
            defaultValue: targetValue?.value,
            maxTagCount: 'responsive',
            showSearch: true,
            onChange(value) {
              const res = {
                comType,
                value,
                extra
              };
              setTargetValue(res);
              cacheHeadFilter.current = {
                ...cacheHeadFilter.current,
                [name]: res
              };
            },
            ...(multiple ? {
              showCheckedStrategy: Cascader.SHOW_CHILD
            } : {})
          }}
          options={options}
          multiple={multiple}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterCascader;
